/* ════════════════════════════════════════════════════════════════════
   TRANSDERMA · Italian (it) · Journal / blog page
   English is the source of truth in blog.html; this file supplies the
   Italian counterpart for each blog.* data-i18n key. Missing keys fall
   back to English automatically (see i18n.js).

   House voice: calm, exact, short. No em dashes (use periods, commas,
   or the mid-dot · ). Product names (Transderma C/A/O/M/R, Discovery
   Kit, Moisture Serum) stay in English. Informal singular "tu".
═════════════════════════════════════════════════════════════════════ */
(function(){
  window.TD_I18N = window.TD_I18N || {};
  window.TD_I18N.it = window.TD_I18N.it || {};
  Object.assign(window.TD_I18N.it, {

    /* ── Footer · extra link not on the homepage ── */
    'footer.learn.about': 'Sul Dr. Ronlán',

    /* ── Page head ── */
    'blog.eyebrow': 'Journal',
    'blog.title': 'Appunti dal<br><em>laboratorio.</em>',
    'blog.intro': 'La scienza, i sieri e i rituali di cura della pelle di Transderma: trent\'anni di ricerca, tradotti per lo scaffale del bagno.',

    /* ── Filter bar ── */
    'blog.filter.all': 'Tutti',
    'blog.filter.science': 'Scienza',
    'blog.filter.ingredients': 'Ingredienti',
    'blog.filter.routines': 'Routine',
    'blog.filter.longevity': 'Longevità',

    /* ── Shared "Read" link ── */
    'blog.read': 'Leggi <span class="arr">→</span>',

    /* ── Coming-soon labels (theme template; articles not yet live) ── */
    'blog.soon': 'In arrivo',
    'blog.notice.upcoming': 'Gli articoli verranno pubblicati a breve · iscriviti qui sotto per essere avvisato',

    /* ── Article 1 (featured) ── */
    'blog.a1.cat': 'Scienza',
    'blog.a1.time': '7 min di lettura',
    'blog.a1.date': 'Apr 2026',
    'blog.a1.title': 'Perché la skincare <em>senza acqua</em> funziona davvero, e perché la maggior parte dei sieri no.',
    'blog.a1.excerpt': 'Tra il sessanta e il novanta per cento del contenuto di un flacone medio di siero è acqua. Il resto è emulsionanti, addensanti e conservanti. Quando diciamo che Transderma è senza acqua, intendiamo che ogni goccia è formula attiva. Ecco la chimica dietro questa scelta, e perché cambia quanto arriva davvero alla pelle.',
    'blog.a1.read': 'Leggi l\'articolo <span class="arr">→</span>',

    /* ── Article 2 ── */
    'blog.a2.cat': 'Ingredienti',
    'blog.a2.time': '5 min',
    'blog.a2.title': 'Retinil palmitato contro retinolo: una via più delicata verso il rinnovamento.',
    'blog.a2.excerpt': 'Perché Serum A usa l\'estere palmitato della vitamina A: come si converte all\'interno della pelle, perché è stabilizzato con la vitamina E, e a chi si adatta meglio.',

    /* ── Article 3 ── */
    'blog.a3.cat': 'Scienza',
    'blog.a3.time': '6 min',
    'blog.a3.title': 'La somministrazione transdermica, spiegata per lo scaffale del bagno.',
    'blog.a3.excerpt': 'Cosa significa davvero "oltre lo strato corneo", come lo squalano trasporta le vitamine attive attraverso lo strato esterno della pelle, e la ricerca in profondità dietro al nome.',

    /* ── Article 4 ── */
    'blog.a4.cat': 'Routine',
    'blog.a4.time': '4 min',
    'blog.a4.title': 'Costruisci una routine Transderma in cinque passaggi.',
    'blog.a4.excerpt': 'Mattina, sera, ordine di applicazione, e come aggiungere Serum M senza diluire l\'attivo sottostante. Il ritmo che trasforma cinque flaconi in un sistema.',

    /* ── Article 5 ── */
    'blog.a5.cat': 'Longevità',
    'blog.a5.time': '8 min',
    'blog.a5.title': 'La questione mitocondriale: perché Serum O è il siero della longevità.',
    'blog.a5.excerpt': 'PQQ, creatina, vitamine B. L\'argomento per trattare l\'invecchiamento della pelle a livello dell\'energia cellulare, e perché il supporto mitocondriale è al centro della formula più distintiva della linea.',

    /* ── Article 6 ── */
    'blog.a6.cat': 'Ingredienti',
    'blog.a6.time': '5 min',
    'blog.a6.title': 'Resveratrolo, piceide e la scienza dietro ai segni post-acne.',
    'blog.a6.excerpt': 'Come quattro ingredienti (e niente acqua) affrontano tono irregolare, danno ambientale e i segni che persistono a lungo dopo la scomparsa del brufolo.',

    /* ── Article 7 ── */
    'blog.a7.cat': 'Scienza',
    'blog.a7.time': '6 min',
    'blog.a7.title': 'Ceramidi, colesterolo e la malta lipidica della pelle.',
    'blog.a7.excerpt': 'Perché una barriera che trattiene la propria idratazione è l\'obiettivo, e come Serum M completa i lipidi che la tua pelle già sa produrre.',

    /* ── Article 8 ── */
    'blog.a8.cat': 'Routine',
    'blog.a8.time': '3 min',
    'blog.a8.title': 'Due gocce bastano. L\'argomento contro l\'uso eccessivo.',
    'blog.a8.excerpt': 'Un siero concentrato senza acqua non si comporta come una crema idratante con il 65 % di acqua. Perché meno materiale arriva più lontano quando la formula lavora con la tua pelle, non contro di essa.',

    /* ── Newsletter ── */
    'blog.news.eyebrow': 'The Journal · Mensile',
    'blog.news.title': 'Una breve lettera <em>ogni mese.</em>',
    'blog.news.body': 'Nuovi articoli, novità discrete sui prodotti e, di tanto in tanto, una parola dal laboratorio. Niente promozioni, niente fronzoli. Una nota meditata e un link di disiscrizione in ogni e-mail.',
    'blog.news.placeholder': 'tua@email.com',
    'blog.news.aria': 'Indirizzo e-mail',
    'blog.news.button': 'Iscriviti'

  });
})();
